import React from "react";
import "./akd.css";
import img from "../../../images/logo.jpg";
import Tafgeet from "tafgeetjs";
const Akd = ({ appdata, userData }) => {
  const days = [
    "اﻷحد",
    "اﻷثنين",
    "الثلاثاء",
    "اﻷربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ];

  const d = new Date();
  let day = days[d.getDay()];
  return (
    <div id="divToPrint">
      <img
        style={{
          width: "150px",
          height: "150px",
          objectFit: "cover",
          borderRadius: "50px",
        }}
        src={img}
        alt=""
      />
      <section
        className="contract"
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "60px 60px 60px 0px",
          border: "2px solid rgba(255, 255, 255, 0.50)",
          background: "rgba(255, 255, 255, 0.20)",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div className="content" style={{ padding: "30px" }}>
          <strong
            className="header"
            style={{
              display: "flex",
              fontSize: "30px",
              justifyContent: "center",
            }}
          >
            عقد بيع سيارة
          </strong>
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div className="">
              <p className="seller-buyer">
                انه فى يوم {day + " "}
                الموافق {d.toLocaleDateString("ar-eg")}
                تحرر هذا العقد بين كل من :-
              </p>
              <p className="seller">
                السيد / {userData && userData.username + " "}
                بطاقة رقم / {userData && userData.national_id + " "} <br />و
                المقيم فى / {userData && userData.address + " "}
              </p>
              <p className="buyer">
                السيد / {appdata.client.client_username + " "}
                بطاقة رقم /{appdata.client.client_national_id + " "} <br />و
                المقيم فى / {appdata.client.client_address + " "}
              </p>
            </div>
            <div
              className=""
              style={{
                width: "40%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "end",
                position: "relative",
                top: "45px",
                left: "220px",
              }}
            >
              <div
                className=""
                style={{
                  height: "90px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <strong>( طرف اول بائع )</strong>
                <strong>( طرف ثاني مشتري )</strong>
              </div>
            </div>
          </div>

          <p>
            ما هو سيارة رقم {" " + appdata.car_details.car_number + " "} ماركة
            {" " + appdata.car_details.category.name + " "} موديل{" "}
            {" " + appdata.car_details.model + " "}
            <br />
            شاسيه {" " + appdata.car_details.chassis_number + " "} موتور{" "}
            {" " + appdata.car_details.motor_number + " "} لون{" "}
            {" " + appdata.car_details.color + " "}و ذلك نظير مبلغ و قدره 
            (
            {new Tafgeet(appdata.car_details&&appdata.car_details.price?appdata.car_details.price:'0', "EGP").parse()})<br />
            (فقط {appdata.car_details.price})
          </p>

          <div className="terms">
            <p>
              <strong>البند الاول : </strong>
              باع واسقط وتنازل الطرف الاول عن ملكيته وكافة حقوقه الخاصة بالسيارة
              للطرف الثاني
            </p>

            <p>
              <strong>البند الثاني : </strong>
              يقر الطرفان بأهليتهما للبيع والشراء وانهما غير خاضعين لأحكام
              الحراسة وغير ممنوعين من التصرف
            </p>

            <p>
              <strong>البند الثالث : </strong>
              يقر الطرف الأول بان السيارة ملكة الخاص ولا يتنازعه في ملكيتها احد
              وانها مسددة الرسوم الجمركة
            </p>

            <p>
              <strong>البند الرابع : </strong>
              يقر البائع بصحة جميع الاوراق الخاصة بالسيارة ( من رخصة و توكيلات و
              عقود مسجلة )
            </p>

            <p>
              <strong>البند الخامس : </strong>
              يقر المشتري بانه عاين السيارة المعاينة النافية للجهالة وقبلها
              بحالتها وبالثمن الموضح علية
            </p>

            <p>
              <strong>البند السادس : </strong>
              يقر البائع بصحة ارقام الشاسية و الموتور و الموديل الموجود بالرخصة
              وانه ان وجد خلاف ذلك اثناء الفحص بمعرفة المرور يكون مسئوال عن ذلك
              ويكون ملزم برد المبلغ المدفوع كثمن السيارة ويعتبر المبلغ امانه
              واجبة السداد طرفة
            </p>

            <p>
              <strong>البند السابع : </strong>
              بعد مرور 24 ساعة من تاريخ العقد ليس لأي من الطرفين الحق في التراجع
            </p>

            <p>
              <strong>البند الثامن : </strong>
              يقر الطرف الاول انه المسئول عن المخلفات والحوادث وما شابه ذلك حتي
              تاريخ البيع
            </p>
            <strong
              className="header"
              style={{
                display: "flex",
                fontSize: "30px",
                justifyContent: "center",
              }}
            >
              اقرار استلام سيارة
            </strong>
            <p className="recive-car">
              اقر انا / ______________ بطاقة رقم / ______________ <br />
              <br />
              المقيم فى / ______________بانني استلمت سيارة رقم / ______________
              ماركة / ______________ يوم / ______________ <br />
              <br /> الموافق _____ / _____ / _________ و انني اصبحت مسؤولا عنها
              فى ناحية المخالفات و الحوادث و ما شابه ذلك
            </p>

            <p>وهذا اقرار مني بذلك</p>
            <p className="signature">
              توقيع المستلم (............................)
            </p>
            <div
              className=""
              style={{
                width: "70%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <p>
                الطرف الاول
                <br />
                الاسم
                <br />
                التوقيع
              </p>
              <p>
                الطرف الاول
                <br />
                الاسم
                <br />
                التوقيع
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Akd;
